export const IconExclamationMarkAttention20: {
  name: 'icon_exclamation_mark_attention_20-8842d4684881'
} = {
  name: 'icon_exclamation_mark_attention_20-8842d4684881'
}
